/**
 * /lib/escape-api.js · thin fetch client for /api/escape/*
 *
 * Doctrine: passes responses through verbatim · never invents fields.
 */
import { BACKEND_URL } from "@/lib/backend-url";

const API = BACKEND_URL;

async function jsonOrThrow(res) {
    if (!res.ok) {
        const err = new Error(`HTTP ${res.status}`);
        err.status = res.status;
        try { err.body = await res.text(); } catch { /* noop */ }
        throw err;
    }
    return res.json();
}

export async function searchEscape(params = {}) {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
        if (v === undefined || v === null || v === "" || v === false) return;
        qs.set(k, String(v));
    });
    const res = await fetch(`${API}/api/escape/search?${qs.toString()}`);
    return jsonOrThrow(res);
}

export async function getEscapeProduct(productCode, { currency = "INR", language = "en-US" } = {}) {
    const qs = new URLSearchParams({ currency, language });
    const res = await fetch(`${API}/api/escape/product/${encodeURIComponent(productCode)}?${qs}`);
    return jsonOrThrow(res);
}

export async function getEscapeAvailability(productCode, { startDate, endDate, currency = "INR" }) {
    const qs = new URLSearchParams({
        start_date: startDate, end_date: endDate, currency,
    });
    const res = await fetch(`${API}/api/escape/product/${encodeURIComponent(productCode)}/availability?${qs}`);
    return jsonOrThrow(res);
}

export async function getEscapeDestinations({ q, type, limit = 50 } = {}) {
    const qs = new URLSearchParams({ limit: String(limit) });
    if (q) qs.set("q", q);
    if (type) qs.set("type", type);
    const res = await fetch(`${API}/api/escape/destinations?${qs}`);
    return jsonOrThrow(res);
}

export async function getEscapeTags() {
    const res = await fetch(`${API}/api/escape/tags`);
    return jsonOrThrow(res);
}

export async function getEscapeSignatures({ destination, country, q, limit = 6 } = {}) {
    const qs = new URLSearchParams({ limit: String(limit) });
    if (destination) qs.set("destination", destination);
    if (country) qs.set("country", country);
    if (q) qs.set("q", q);
    const res = await fetch(`${API}/api/escape/signature?${qs}`);
    return jsonOrThrow(res);
}

export async function getEscapeSignature(id) {
    const res = await fetch(`${API}/api/escape/signature/${encodeURIComponent(id)}`);
    return jsonOrThrow(res);
}

export async function getEscapeSignatureViatorPhotos(id, { count = 6 } = {}) {
    const res = await fetch(`${API}/api/escape/signature/${encodeURIComponent(id)}/viator-photos?count=${count}`);
    return jsonOrThrow(res);
}

/**
 * Universal click-intent · surface=escape · rail=viator|signature
 * Fire-and-forget · never blocks the member opening Viator.
 */
export function logEscapeIntent({ rail, entityId, entitySnapshot }) {
    try {
        fetch(`${API}/api/click/intent`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                surface: "escape",
                rail: rail || "viator",
                entity_id: entityId,
                entity_snapshot: entitySnapshot || {},
                intent_type: "direct_book_click",
                fyi_to_zoho: true,
            }),
            keepalive: true,
        });
    } catch { /* never block */ }
}
